module.exports = __webpack_public_path__ + "static/img/scc2.dcee06a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/scc2.webp
// module id = t9Ue
// module chunks = 1